import atlasApi from '..'

const faqPrefix = '/brands/v2/faq'

const getFaq = async (params) => {
  return atlasApi.get(faqPrefix, params)
}

export { getFaq }
